import { MODULE_TYPES_MAP } from 'src/constants/m-line';

export const MODULE_TRANSACTIONS_FILTER_STATES = {
  ALL: 'All',
  PENDING: 'Pending',
  RECONCILED: 'Reconciled',
};

export const MODULE_TRANSACTIONS_CONTAINER_TYPES = {
  ALL: 'All',
  ...MODULE_TYPES_MAP,
};
